export default __webpack_public_path__ + "static/DG_logo_mid_res-5b927d28918492f969d6d0b59e34728b.jpg";